function tabGroupComponent() {
    return {
        init() {
            this.$root.addEventListener('click', (e) => {
                const target = e.target;
                if (!target.classList.contains('tab')) return;

                const container = target.closest('.tab-group-container');
                const targetContentClass = target.getAttribute('data-target');
                const allTabs = container.querySelectorAll('.tab');
                const allContents = container.querySelectorAll('.tab-page');
                const url = target.getAttribute('data-url');

                allTabs.forEach(tab => tab.classList.remove('tab-active'));
                allContents.forEach(content => content.classList.add('hidden'));

                target.classList.add('tab-active');
                container.querySelectorAll('.' + targetContentClass)
                    .forEach(content => content.classList.remove('hidden'));

                if (url) {
                    window.history.pushState({ path: url }, '', url);
                }
            });
        }
    };
}

window.TabGroupComponent = tabGroupComponent;
